import * as React from 'react';

import { PublishedConnections } from '~src/publishedConnection/resources/PublishedConnections';
import { ISpaceItemDetailInfo } from '~src/ts/models/ISpaceItemDetailInfo';

import { Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { doesTooltipNotHaveOwnerToDisplay } from '../Tooltips/Elements/Tooltip';
import { PublishedConnectionTooltip } from '../Tooltips/PublishedConnectionTooltip';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, getContentUrlForItem } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { Thumbnail } from './Thumbnail';

const CertificationCardStyle: React.CSSProperties = {
  paddingTop: '3px',
  marginLeft: '-9px',
  marginRight: '-3px',
};

export class PublishedConnectionCard extends ContentCard {
  public render() {
    const contentUrl = getContentUrlForItem(this.props.content, this.props.urls);

    const imageUrl = PublishedConnections.getPublishedConnectionIconPath(this.props.content as ISpaceItemDetailInfo<'publishedConnection'>, true);

    const publishedConnection = this.props.content;

    const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(this.props.content);

    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor
          tooltipContent={this.renderTooltipContent}
          width={DetailsTooltipStyles.Width}
          onShowTooltip={this.handleShowTooltip}
          title={Messages.publishedConnectionTooltipTitle()}
          disableAutoFocus={disableAutoFocus}
          disableTooltip={this.props.disableTooltip}
        >
          <Thumbnail
            defaultImageUrl={imageUrl}
            thumbnailImageUrl={this.props.content.thumbnailUrl}
            hoveredOrSelected={this.props.hoveredOrSelected}
            navigateUrl={contentUrl}
            useBase64EncodedImage={true}
            allowDragAndDrop={this.props.allowDragAndDrop}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span data-tb-test-id="publishedConnection-name" className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            {this.props.content.name}
          </span>
          {this.showFavoritesStar() && <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'publishedConnection' })}
              onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'publishedConnection' })}
            />
          </span>}
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return (
      <PublishedConnectionTooltip
        content={this.props.content}
        urls={this.props.urls}
        inProjectSpace={this.props.inProjectSpace}
      />
    );
  }
}
